module.exports = __webpack_public_path__ + "resources/img/img_dvision4_m.9c621180351f41b643650bf8da25e0eb.png";